
<section class="pt-4">

    
    <div class="d-flex  justify-content-between align-items-center px-5 py-4">

      <ng-container *ngIf="!valideNegative(this.datos.pay_amount)">
        <h2 class="text-left text-white px-4 my-4">Ingreso de pago para el proyecto: {{name}} </h2>
    </ng-container>
    <ng-container *ngIf="valideNegative(this.datos.pay_amount)">
      <h2 class="text-left text-white px-4 my-4">Ingreso descuento para el proyecto: {{name}} </h2>
  </ng-container>



      <button
        class="badge rounded-pill btn btn-outline-light"
        [routerLink]="['/pdg/project/pay/list', idProject, name]"
      >
        <i
          class="fa-solid fa-right-from-bracket m-2 fs-6"
          aria-hidden="true"
        ></i>
        <span class="m-2 fs-6">Volver al listado</span>
      </button>

    </div>
  

  
  <div *ngIf="this.datos.title != null" class="mx-5 py-4">
    <div class="container-fluid text-white d-flex justify-content-between">
      <div>
        <span>Tipo:  </span>
        <span>{{ this.datos.title }}</span>
      </div>
      <div>
        <span>Monto:  </span>
        <span>{{ this.datos.pay_amount }}</span>
      </div>
      <div>
        <span>Porcentaje:  </span>
        <span>{{ this.datos.amount_percent }}%</span>
      </div>
      <div>
        <span>Fecha:  </span>
        <span>{{ this.datos.scheduled_date }}</span>
      </div>
      <div>
        <span>Estados:  </span>
            <span *ngIf="this.datos.status === 'REPROGRAMADO'"
                class="badge rounded-pill text-bg-warning " style="font-size: 12px;">{{this.datos.status}}</span>
                <span *ngIf="this.datos.status === 'PAGADO'"
                class="badge rounded-pill text-bg-success  " style="font-size: 12px;">{{this.datos.status}}</span>
                <span *ngIf="this.datos.status === 'ANULADO'"
                class="badge rounded-pill text-bg-danger " style="font-size: 12px;">{{this.datos.status}}</span>
                <span *ngIf="this.datos.status === 'PENDIENTE'"
                class="badge rounded-pill text-bg-info" style="font-size: 12px;">{{this.datos.status}}</span>
                <span *ngIf="this.datos.status === 'DESCONTADO'"
                class="badge rounded-pill text-bg-desc" style="font-size: 12px;">{{this.datos.status}}</span>
                <span *ngIf="this.datos.status === 'CREADO'"
                class="badge rounded-pill text-bg-creado p-2 " style="font-size: 12px;">{{this.datos.status}}</span>
      </div>


    </div>
  </div>

  <div class="mx-5">
    <div class="container-fluid ">
      <div class="backgroundTable">

        <table  datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="componente-importantes componente-importantes-from-popup">
          
          <ng-container *ngIf="ListPay.length == 0">">
            <div class="text-center text-white">
              <h2 class="text-white px-5 mt-5">Sin Registro</h2>
              <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
            </div>
          </ng-container>

          <ng-container *ngIf="ListPay.length != 0">
          <thead>
            <tr>
              <th class="text-white text-center">Acción</th>
              <th class="text-white text-center">Observaciones</th>
              <th class="text-white text-center">Usuario Responsable</th>
              <th class="text-white text-center">Feha creacion</th>
             
          </thead>

          <tbody>
            <tr *ngFor="let item of ListPay">

              <td class="text-center pointer">{{item.action}}</td>
              <td class="text-center pointer">{{item.description ? item.description : 'Sin registro.'}}</td>
              <td class="text-center pointer">{{item.username}}</td>
              <td class="text-center pointer">{{item.created}}</td>
       

            </tbody>
          </ng-container>
            </table>
           

          </div>
          
        </div>
  </div>

          
    </section>